import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

export const Home = () => {
  return (
    <>
      <section className="flex items-center flex-row justify-center items-center h-3/5 mt-20 sm:flex-col mt-1 ">
        <div className="card bg-base-100 shadow-2xl m-10 sm:w-4/5 md:w-3/5 xl:w-1/5">
          <figure className="containerImage">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/recruiter.svg"}
              className="h-80 lg:h-4/5 p-10"
              alt="Imagen animada de un/una recruiter"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title md:h-20 xl:h-24">
              ¿Tenés interés en contratarme?
            </h2>
            <p className="h-20 xl:h-24">
              En el siguiente link vas a poder ver más info acerca de mi
            </p>
            <div className="card-actions justify-end">
              <Link to="/recruiter" className="btn btn-primary">
                Ver más
              </Link>
            </div>
          </div>
        </div>
        <div className="card bg-base-100 shadow-xl m-10  sm:w-4/5 md:w-3/5 xl:w-1/5">
          <figure className="containerImage">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/cvHome.svg"}
              className="h-80 lg:h-4/5 p-10"
              alt="Imagen animada de un programador"
            />
          </figure>
          <div className="card-body">
            <h2 className="card-title md:h-20 xl:h-24">¿Querés ver mi CV?</h2>
            <p className="h-20 xl:h-24">
              En el siguiente link vas a poder verlo y/o descargarlo
            </p>
            <div className="card-actions justify-end">
              <Link to={"/cv"} className="btn btn-primary">
                Ver CV
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
